// One event per color with and without resource

export const defaultVisibleDate = new Date('2025-07-01T00:00:00');

export const initialEventsWithResources = [
  {
    id: 'purple',
    start: '2025-06-30T02:00:00',
    end: '2025-06-30T04:00:00',
    title: 'purple',
    resource: 'purple',
  },
  {
    id: 'teal',
    start: '2025-06-30T05:00:00',
    end: '2025-06-30T07:00:00',
    title: 'teal',
    resource: 'teal',
  },
  {
    id: 'lime',
    start: '2025-07-01T02:00:00',
    end: '2025-07-01T04:00:00',
    title: 'lime',
    resource: 'lime',
  },
  {
    id: 'orange',
    start: '2025-07-01T05:00:00',
    end: '2025-07-01T07:00:00',
    title: 'orange',
    resource: 'orange',
  },
  {
    id: 'green',
    start: '2025-07-02T02:00:00',
    end: '2025-07-02T04:00:00',
    title: 'green',
    resource: 'green',
  },
  {
    id: 'pink',
    start: '2025-07-02T05:00:00',
    end: '2025-07-02T07:00:00',
    title: 'pink',
    resource: 'pink',
  },
  {
    id: 'indigo',
    start: '2025-07-03T02:00:00',
    end: '2025-07-03T04:00:00',
    title: 'indigo',
    resource: 'indigo',
  },
  {
    id: 'amber',
    start: '2025-07-03T05:00:00',
    end: '2025-07-03T07:00:00',
    title: 'amber',
    resource: 'amber',
  },
  {
    id: 'blue',
    start: '2025-07-04T02:00:00',
    end: '2025-07-04T04:00:00',
    title: 'blue',
    resource: 'blue',
  },
];

export const initialEventsWithoutResources = [
  {
    id: 'purple',
    start: '2025-06-30T02:00:00',
    end: '2025-06-30T04:00:00',
    title: 'purple',
    color: 'purple',
  },
  {
    id: 'teal',
    start: '2025-06-30T05:00:00',
    end: '2025-06-30T07:00:00',
    title: 'teal',
    color: 'teal',
  },
  {
    id: 'lime',
    start: '2025-07-01T02:00:00',
    end: '2025-07-01T04:00:00',
    title: 'lime',
    color: 'lime',
  },
  {
    id: 'orange',
    start: '2025-07-01T05:00:00',
    end: '2025-07-01T07:00:00',
    title: 'orange',
    color: 'orange',
  },
  {
    id: 'green',
    start: '2025-07-02T02:00:00',
    end: '2025-07-02T04:00:00',
    title: 'green',
    color: 'green',
  },
  {
    id: 'pink',
    start: '2025-07-02T05:00:00',
    end: '2025-07-02T07:00:00',
    title: 'pink',
    color: 'pink',
  },
  {
    id: 'indigo',
    start: '2025-07-03T02:00:00',
    end: '2025-07-03T04:00:00',
    title: 'indigo',
    color: 'indigo',
  },
  {
    id: 'amber',
    start: '2025-07-03T05:00:00',
    end: '2025-07-03T07:00:00',
    title: 'amber',
    color: 'amber',
  },
  {
    id: 'blue',
    start: '2025-07-04T02:00:00',
    end: '2025-07-04T04:00:00',
    title: 'blue',
    color: 'blue',
  },
];

export const resources = [
  { title: 'purple', id: 'purple', eventColor: 'purple' },
  { title: 'teal', id: 'teal', eventColor: 'teal' },
  { title: 'lime', id: 'lime', eventColor: 'lime' },
  { title: 'orange', id: 'orange', eventColor: 'orange' },
  { title: 'green', id: 'green', eventColor: 'green' },
  { title: 'pink', id: 'pink', eventColor: 'pink' },
  { title: 'indigo', id: 'indigo', eventColor: 'indigo' },
  { title: 'amber', id: 'amber', eventColor: 'amber' },
  { title: 'blue', id: 'blue', eventColor: 'blue' },
];
